import { createAction, createSlice } from "@reduxjs/toolkit";

const isSubscribedSlice = createSlice({
  name: "isSubscribed",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    reset(state) {
      state.data = null;
    },
  },
});

const { name, actions, reducer } = isSubscribedSlice;
const isSubscribedAction = createAction(name);

export {
  isSubscribedAction,
  actions as isSubscribedActions,
  reducer as isSubscribedReducer,
};
